{
  "_meta": {
    "_comment": "Admin vendors namespace. Phase 18 Task 34 added detail.tabs.integration. vg-binding: P18.D-21 | vg-binding: PLAN:task-34",
    "locale": "en"
  },
  "list": {
    "page": {
      "heading": "Vendors",
      "subtitle": "Manage vendor identity, KYC, activation, capacity, and at-risk posture. Click a row for the vendor detail page."
    },
    "filter": {
      "showClosed": "Show closed vendors"
    },
    "empty": {
      "message": "No vendors match your filters."
    },
    "legend": {
      "label": "Row legend:",
      "suspended": "Suspended",
      "atRisk": "At-Risk",
      "lowRating": "Low rating (< 0.5)",
      "pendingActivation": "Pending Activation",
      "ariaLabel": "Row color legend"
    },
    "wallet": {
      "onHold": "On hold",
      "open": "Open",
      "onHoldTitle": "Wallet on hold — payouts blocked by admin"
    },
    "kyc": {
      "pendingTitle": "Payout blocked. Orders allowed."
    },
    "capabilities": {
      "pendingTitle": "Pending capability proposals"
    },
    "toast": {
      "actionRequiresDetailTitle": "Action requires detail page",
      "actionRequiresDetailDesc": "Open the vendor detail page to complete this action. Bulk modal lands in Wave 5.",
      "activationQueueTitle": "Approve in the pending queue",
      "activationQueueDesc": "Opened the pending-vendor queue — click the vendor row to review and approve activation.",
      "suspendedTitle": "Vendor suspended",
      "reactivatedTitle": "Vendor reactivated",
      "networkError": "Network error — check connection",
      "noVendorsTitle": "No vendors selected",
      "noVendorsDesc": "Select at least one vendor to run this bulk action.",
      "reasonRequiredTitle": "Reason required",
      "reasonRequiredDesc": "Provide a 10–500 character reason to proceed.",
      "dualApprovalTitle": "Dual approval required",
      "dualApprovalDesc": "Request {{approvalId}} queued (SLA {{slaMinutes}} min, {{vendorCount}} vendors).",
      "jobQueuedTitle": "Job queued",
      "jobQueuedDesc": "Background job {{jobId}}. Track via {{pollUrl}}.",
      "bulkCompleteTitle": "Bulk action complete",
      "bulkCompleteDesc": "{{count}} vendors updated.",
      "partialSuccessTitle": "Partial success",
      "partialSuccessDesc": "{{succeeded}} succeeded, {{failed}} failed.",
      "bulkFailedTitle": "Bulk action failed"
    },
    "bulkActions": {
      "suspend": "Suspend",
      "suspendLabel": "Suspend vendors",
      "activate": "Activate",
      "activateLabel": "Activate vendors",
      "holdWallet": "Hold wallet",
      "holdWalletLabel": "Hold wallet for vendors",
      "releaseWallet": "Release wallet",
      "releaseWalletLabel": "Release wallet for vendors",
      "exportCsv": "Export CSV",
      "exportLabel": "Export vendors",
      "perVendorSuspendLabel": "Suspend vendor",
      "perVendorReactivateLabel": "Reactivate vendor"
    },
    "actions": {
      "confirm": "Confirm",
      "vendorSettings": "Vendor Settings",
      "createVendor": "Create vendor",
      "importVendors": "Import"
    }
  },
  "listColumns": {
    "headers": {
      "name": "Vendor",
      "status": "Status",
      "wallet": "Wallet",
      "kyc": "KYC",
      "rating": "Rating",
      "utilization": "Utilization",
      "pendingOrders": "Pending",
      "sla": "SLA",
      "backOrder": "Back-order",
      "totalEarned": "Total earned",
      "pendingPayout": "Pending payout",
      "atRisk": "At-risk",
      "capPending": "Cap. pending",
      "region": "Region",
      "created": "Created"
    },
    "filters": {
      "search": {
        "label": "Search",
        "placeholder": "Name, email, phone, ID…"
      },
      "status": {
        "label": "Status",
        "options": {
          "pending_activation": "Pending Activation",
          "active": "Active",
          "inactive": "Inactive",
          "suspended": "Suspended",
          "closed": "Closed"
        }
      },
      "wallet": {
        "label": "Wallet",
        "options": {
          "hold": "On hold",
          "open": "Open"
        }
      },
      "kyc": {
        "label": "KYC",
        "options": {
          "approved": "Approved",
          "pending": "Pending",
          "rejected": "Rejected"
        }
      },
      "atRisk": {
        "label": "At-risk severity",
        "options": {
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        }
      },
      "region": {
        "label": "Region",
        "placeholder": "Country / region code"
      }
    }
  },
  "rowMenu": {
    "menuAria": "Vendor {{id}} actions",
    "triggerAria": "Open actions for vendor {{id}}",
    "items": {
      "view": "View detail",
      "approve_kyc": "Approve KYC",
      "approve_activation": "Approve activation",
      "capability_review": "Capability Review",
      "acknowledge_at_risk": "Acknowledge At-Risk",
      "reactivate": "Reactivate",
      "suspend": "Suspend"
    }
  },
  "tabs": {
    "listAria": "Vendor list tabs",
    "countAria": "{{count}} vendors",
    "labels": {
      "all": "All",
      "pending_activation": "Pending Activation",
      "active": "Active",
      "inactive": "Inactive",
      "suspended": "Suspended",
      "pending_cost_approvals": "Pending Cost Approvals",
      "pending_capabilities": "Pending Capabilities",
      "at_risk": "At Risk"
    },
    "descriptions": {
      "all": "All vendors regardless of status.",
      "pending_activation": "Vendors awaiting admin approval. New vendors land here until activated.",
      "pending_cost_approvals": "Vendors with open cost-approval requests. Surfaced from Phase 7 backend.",
      "pending_capabilities": "Vendors with pending capability proposals. Each proposal needs admin review.",
      "at_risk": "Vendors flagged by the at-risk scan. Includes low_rating, high_rejection, complaint_spike."
    }
  },
  "pinnedOverview": {
    "cards": {
      "profile": "Profile",
      "performance": "Performance",
      "capacity": "Capacity",
      "financial": "Financial"
    },
    "profile": {
      "email": "Email",
      "phone": "Phone",
      "country": "Country",
      "primaryContact": "Primary contact",
      "tier": "Tier",
      "yearsActive": "Years active"
    },
    "performance": {
      "rating": "Rating",
      "delta30d": "Δ 30d",
      "orders30d": "Orders 30d",
      "rejectionRate": "Rejection rate",
      "slaCompliance": "SLA compliance",
      "manualAdjust": "Manual Adjust Rating"
    },
    "capacity": {
      "costGatedMsg": "Cost-gated — request VIEW_FINANCIAL_COST permission to view capacity utilisation.",
      "slots": "slots",
      "frozen": "frozen"
    },
    "financial": {
      "wallet": "Wallet",
      "pendingPayout": "Pending payout",
      "earnings30d": "Earnings 30d",
      "outstandingInvoice": "Outstanding invoice"
    }
  },
  "detail": {
    "tabs": {
      "ariaLabel": "Vendor detail sections",
      "locations": "Locations",
      "capabilities": "Capabilities",
      "products": "Products",
      "pending-cost-approvals": "Cost Approvals",
      "recent-orders": "Recent Orders",
      "financial": "Financial",
      "activity-log": "Activity",
      "notes": "Notes",
      "kyc": "KYC",
      "staff-accounts": "Staff",
      "sla-chart": "SLA",
      "integration": "Integration",
      "badgeNew": "NEW"
    },
    "backLink": "Back to Vendors",
    "loading": "Loading vendor…",
    "error": {
      "missingId": "Missing vendor id in route — cannot render vendor detail.",
      "loadFail": "Failed to load vendor: {{message}}",
      "noData": "No vendor data returned.",
      "impersonateNoUrl": "Impersonate cookie set but no redirect URL returned — open the vendor portal manually.",
      "cannotImpersonate": "Your role cannot impersonate vendors."
    },
    "ratingModal": {
      "title": "Manual Rating Override",
      "description": "This action is logged to the vendor audit trail with before / after values and your reason. The override remains active until another admin clears it.",
      "newRatingLabel": "New rating: {{value}} / 5",
      "reasonLabel": "Reason (min 10 chars)",
      "reasonTooShort": "Reason must be at least 10 characters (audit requirement).",
      "unknownError": "Unknown error",
      "cancel": "Cancel",
      "saving": "Saving…",
      "save": "Save override"
    },
    "confirmDialog": {
      "reasonLabel": "Reason (optional)",
      "unknownError": "Unknown error",
      "cancel": "Cancel",
      "working": "Working…"
    },
    "walletAdjustPlaceholder": {
      "title": "Wallet Adjustment",
      "description": "The full Vendor Wallet Adjustment modal ships in task-26 (§7.1). For now this placeholder signals the action — the actual mutation flow will land in Wave 7.",
      "close": "Close"
    },
    "confirm": {
      "suspend": {
        "title": "Suspend vendor",
        "body": "Suspending the vendor prevents new order routing. Open orders are not cancelled — they continue to fulfil.",
        "cta": "Confirm suspend"
      },
      "reactivate": {
        "title": "Reactivate vendor",
        "body": "Reactivate this vendor so new orders can route to them again.",
        "cta": "Confirm reactivate"
      },
      "walletHoldOn": {
        "title": "Hold vendor wallet",
        "body": "Hold the wallet — payouts and withdrawals are blocked until released.",
        "cta": "Hold wallet"
      },
      "walletHoldOff": {
        "title": "Release vendor wallet",
        "body": "Release the wallet hold so payouts and withdrawals resume.",
        "cta": "Release wallet"
      }
    }
  },
  "stickyHeader": {
    "statusLabels": {
      "Active": "Active",
      "Pending": "Pending Activation",
      "PendingActivation": "Pending Activation",
      "Suspended": "Suspended",
      "Inactive": "Inactive",
      "AtRisk": "At-Risk"
    },
    "rating": {
      "manualTitle": "Manual rating override — current {{value}} / 5",
      "currentTitle": "Current rating {{value}} / 5",
      "manual": "Manual",
      "manualAdjust": "Manual Adjust"
    },
    "online": {
      "online": "Online",
      "lastSeen": "Last seen {{date}}",
      "offline": "Offline"
    },
    "actions": {
      "edit": "Edit",
      "reactivate": "Reactivate",
      "suspend": "Suspend",
      "releaseWallet": "Release Wallet",
      "holdWallet": "Hold Wallet",
      "loginAsVendor": "Login as Vendor"
    },
    "walletHoldBadge": "Wallet on hold"
  },
  "reviewDrawer": {
    "title": "Vendor Review",
    "close": "Close",
    "ariaLabel": "Vendor review drawer",
    "closeAriaLabel": "Close vendor drawer",
    "notFound": "Vendor not found.",
    "toast": {
      "loadFail": "Failed to load vendor",
      "networkError": "Network error",
      "unknown": "Unknown",
      "approveFail": "Approve failed",
      "approveSuccess": "Vendor approved",
      "approveSuccessDesc": "{{displayName}} is now Active.",
      "rejectReasonShort": "Rejection reason too short",
      "rejectReasonShortDesc": "Minimum 10 characters required.",
      "rejectFail": "Reject failed",
      "rejectSuccess": "Vendor rejected",
      "rejectSuccessDesc": "Email notification queued; cooldown applied."
    },
    "profile": {
      "heading": "Profile",
      "displayName": "Display name",
      "phone": "Phone",
      "country": "Country",
      "status": "Status",
      "applied": "Applied",
      "lastReject": "Last reject"
    },
    "survey": {
      "heading": "Survey Responses",
      "empty": "Vendor did not complete the registration survey."
    },
    "actions": {
      "reject": "Reject",
      "approve": "Approve",
      "rejectReasonLabel": "Rejection reason (10-2000 chars)",
      "rejectReasonPlaceholder": "Explain why this vendor application is rejected. Sent in email.",
      "cancel": "Cancel",
      "confirmReject": "Confirm reject"
    },
    "registration": {
      "heading": "Registration details",
      "businessName": "Business name",
      "legalName": "Legal name",
      "timezone": "Timezone",
      "shippingMode": "Shipping mode",
      "techniques": "Techniques",
      "warehouse": "Warehouse"
    }
  },
  "sections": {
    "activityLog": {
      "title": "Activity Log",
      "categoryFilter": {
        "ariaLabel": "Activity category filter",
        "admin_action": "Admin actions",
        "vendor_action": "Vendor actions",
        "system_event": "System events",
        "order_lifecycle": "Order lifecycle"
      },
      "loading": "Loading activity…",
      "pendingLabel": "No activity — endpoint in development.",
      "empty": "No activity matches the current filter.",
      "actorPrefix": "By {{actor}}",
      "loadingMore": "Loading…",
      "loadMore": "Load more",
      "unknownAction": "Activity",
      "actions": {
        "VENDOR_CREATED": "Vendor created",
        "VENDOR_SUSPENDED": "Vendor suspended",
        "VENDOR_REACTIVATED": "Vendor reactivated",
        "VENDOR_ACTIVATION_APPROVED": "Vendor activation approved",
        "VENDOR_ACTIVATION_REJECTED": "Vendor activation rejected",
        "VENDOR_AT_RISK_ACKNOWLEDGED": "At-risk flag acknowledged",
        "VENDOR_BANK_VERIFIED": "Bank account verified",
        "VENDOR_BANK_REJECTED": "Bank account rejected",
        "VENDOR_BULK_IMPORT": "Imported in bulk",
        "VENDOR_CAPABILITY_ASSIGNED": "Capability assigned",
        "VENDOR_CAPABILITY_PROPOSAL_APPROVED": "Capability proposal approved",
        "VENDOR_CAPABILITY_PROPOSAL_REJECTED": "Capability proposal rejected",
        "VENDOR_COST_APPROVAL_APPROVED": "Cost change approved",
        "VENDOR_COST_APPROVAL_REJECTED": "Cost change rejected",
        "VENDOR_WALLET_ADJUST_REQUESTED": "Wallet adjustment requested",
        "VENDOR_WALLET_ADJUST_APPLIED": "Wallet adjustment applied",
        "VENDOR_UPDATED": "Vendor profile updated",
        "KYC_DOCUMENT_APPROVED": "KYC document approved",
        "KYC_DOCUMENT_REJECTED": "KYC document rejected",
        "KYC_DOCUMENT_VIEWED": "KYC document viewed",
        "AUTH_LOGIN": "Signed in",
        "AUTH_LOGOUT": "Signed out",
        "AUTH_VENDOR_APPROVE": "Vendor application approved",
        "AUTH_VENDOR_REJECT": "Vendor application rejected",
        "AUTH_VENDOR_REAPPLY": "Vendor re-applied",
        "ORDER_ITEM_VENDOR_OVERRIDDEN": "Order item vendor overridden",
        "WITHDRAW_PERMISSION_UPDATED": "Withdrawal permission updated",
        "GDPR_GRANDFATHER_EXPIRED": "Consent grace period expired",
        "AUTH_REFRESH_FAILED": "Session refresh failed",
        "AUTH_REFRESH": "Session refreshed",
        "AUTH_2FA_VERIFY": "Two-factor verified",
        "AUTH_2FA_SETUP": "Two-factor set up",
        "AUTH_2FA_DISABLED": "Two-factor disabled",
        "AUTH_2FA_CHALLENGE": "Two-factor challenge issued",
        "AUTH_USER_2FA_RESET": "Two-factor reset by admin",
        "AUTH_LOGIN_FAILED": "Sign-in failed",
        "AUTH_LOGIN_LOCKED": "Account locked after failed sign-ins",
        "AUTH_PASSWORD_CHANGE": "Password changed",
        "AUTH_REGISTER": "Account registered",
        "AUTH_PROFILE_UPDATE": "Profile updated",
        "AUTH_BILLING_UPDATE": "Billing details updated",
        "AUTH_USER_UPDATE": "Account updated",
        "AUTH_USER_SUSPEND": "Account suspended",
        "AUTH_USER_UNSUSPEND": "Account unsuspended",
        "AUTH_USER_ROLE_GRANT": "Role granted",
        "AUTH_USER_ROLE_REVOKE": "Role revoked",
        "AUTH_SESSION_REVOKED": "Session revoked",
        "AUTH_IMPERSONATE_START": "Impersonation started",
        "AUTH_SURVEY_SUBMIT": "Survey submitted",
        "AUTH_WS_SUBSCRIBE_DENIED": "Realtime subscription denied",
        "vendor.capacity.current_active_changed": "Active capacity changed",
        "vendor.assignment.suspension_cascade": "Assignments moved after suspension",
        "payout.approved": "Payout approved",
        "payout.rejected": "Payout rejected",
        "payout.mark_transferred": "Payout marked transferred",
        "support_ticket.created": "Support ticket created",
        "support_ticket.updated": "Support ticket updated",
        "support_ticket.escalated": "Support ticket escalated",
        "support_ticket_message.created": "Support ticket reply",
        "CATEGORY_CREATED": "Category created",
        "CATEGORY_UPDATED": "Category updated",
        "CATEGORY_REORDERED": "Categories reordered",
        "COLLECTION_CREATED": "Collection created",
        "COLLECTION_UPDATED": "Collection updated",
        "COLLECTION_REORDERED": "Collections reordered",
        "OPTION_CREATED": "Option created",
        "OPTION_UPDATED": "Option updated",
        "OPTION_DELETED": "Option deleted",
        "blueprint:create": "Blueprint created",
        "blueprint:update": "Blueprint updated",
        "products_special.create": "Special product created",
        "products_special.update_assignments": "Special product assignments updated",
        "INVENTORY_STOCK_VIEW": "Stock viewed",
        "INVENTORY_OVERVIEW_VIEW": "Inventory overview viewed",
        "INVENTORY_REPORT_MOVEMENT_EXPORT": "Stock movement report exported",
        "INVENTORY_REPORT_STOCK_LEVEL_EXPORT": "Stock level report exported",
        "INVENTORY_REPORT_AGING_EXPORT": "Stock aging report exported",
        "INVENTORY_REPORT_VALUATION_EXPORT": "Stock valuation report exported",
        "INVENTORY_REPORT_TURNOVER_EXPORT": "Stock turnover report exported",
        "FRAUD_SETTINGS_UPDATED": "Fraud settings updated",
        "ADMIN_ROLE_CREATE": "Admin role created",
        "ADMIN_ROLE_DELETE": "Admin role deleted",
        "settings.update": "Settings updated",
        "EMERGENCY_MODE_ACTIVATED": "Emergency mode activated",
        "SYSTEM_BACKUP_TRIGGERED": "System backup triggered",
        "LEGAL_ENTITY_CREATED": "Legal entity created",
        "merchant_invoice_created": "Merchant invoice created",
        "invoice_pdf_download": "Invoice PDF downloaded",
        "admin_invoice_pdf_download": "Invoice PDF downloaded by admin",
        "admin_payment_request_create": "Payment request created",
        "admin_payment_request_pdf_download": "Payment request PDF downloaded",
        "billing_address_create": "Billing address created",
        "billing.mode.switched": "Billing mode switched",
        "billing.invoice.manually_generated": "Invoice generated manually",
        "billing.refund_task.completed": "Refund task completed"
      },
      "fields": {
        "status": "Status",
        "activation_status": "Activation status",
        "kyc_status": "KYC status",
        "reason": "Reason",
        "rejectReason": "Rejection reason",
        "reject_reason": "Rejection reason",
        "note": "Note",
        "tier": "Tier",
        "vendorTier": "Tier",
        "amount": "Amount",
        "payout_blocked": "Payouts blocked"
      }
    },
    "capabilities": {
      "title": "Capabilities",
      "loading": "Loading capabilities…",
      "pendingLabel": "No capabilities — endpoint in development.",
      "empty": "No capabilities recorded.",
      "status": {
        "approved": "Approved",
        "proposed": "Proposed",
        "rejected": "Rejected"
      },
      "productCount": "{{count}} products",
      "actions": {
        "approve": "Approve",
        "reject": "Reject",
        "cancel": "Cancel",
        "confirmReject": "Confirm Reject"
      },
      "rejectReasonLabel": "Reason for rejection",
      "errors": {
        "reasonRequired": "Rejection reason is required.",
        "unknown": "Unknown error"
      }
    },
    "financial": {
      "title": "Financial",
      "costGate": "Financial details are restricted. Your role does not include the financial-cost view permission. Contact a Super Admin for access.",
      "loading": "Loading financial…",
      "noData": "No financial data.",
      "subBlocks": {
        "earnings": "Earnings",
        "earningsPipeline": "Earnings Pipeline",
        "payouts": "Payouts",
        "walletAdjustments": "Wallet Adjustments",
        "bankAccounts": "Bank Accounts"
      },
      "earningsPipelineLabel": "Pipeline:",
      "noEarnings": "No earnings data.",
      "noPayouts": "No payouts scheduled.",
      "noWalletAdjustments": "No wallet adjustments on record.",
      "noBankAccounts": "No bank accounts on file.",
      "createAdjustment": "+ Create Adjustment",
      "earningsChartAriaLabel": "Earnings chart",
      "payoutStatus": {
        "paid": "Paid",
        "scheduled": "Scheduled",
        "held": "Held",
        "failed": "Failed"
      },
      "defaultBadge": "Default",
      "bankVerifiedBadge": "Verified",
      "bankPendingBadge": "Pending",
      "bankVerify": "Verify",
      "bankReview": "Review",
      "columns": {
        "date": "Date",
        "amount": "Amount",
        "status": "Status",
        "reference": "Reference"
      }
    },
    "kyc": {
      "title": "KYC",
      "loading": "Loading KYC…",
      "pendingLabel": "No KYC records — endpoint in development.",
      "noData": "No KYC data.",
      "payoutsBlockedBanner": {
        "heading": "Payouts blocked.",
        "body": "Pre-KYC vendors can still accept orders; payouts and withdrawals stay blocked until KYC is verified."
      },
      "docLabels": {
        "business_license": "Business License",
        "tax_certificate": "Tax Certificate",
        "identity": "Identity (passport / national ID)",
        "bank_proof": "Bank Account Proof"
      },
      "submittedAt": "Submitted {{date}}",
      "reviewedAt": "Reviewed {{date}}",
      "viewDocument": "View document",
      "approve": "Approve",
      "reject": "Reject",
      "rejectConfirm": "Confirm reject",
      "cancel": "Cancel",
      "rejectReasonPlaceholder": "Reason (min 10 chars) — sent to vendor",
      "actionFailed": "Action failed — please retry"
    },
    "locations": {
      "title": "Locations",
      "loading": "Loading locations…",
      "pendingLabel": "No locations — endpoint in development.",
      "empty": "No locations on file for this vendor.",
      "badge": {
        "primary": "Primary",
        "frozen": "Frozen"
      },
      "freeze": {
        "working": "Working…",
        "unfreeze": "Unfreeze",
        "freeze": "Freeze Location"
      },
      "confirmDialog": {
        "ariaLabel": "Confirm freeze location",
        "unfreezePrompt": "Unfreeze this location? Capacity slots become bookable again.",
        "freezePrompt": "Freeze this location? Other vendor locations are unaffected. Soft freeze — existing orders proceed.",
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "errors": {
        "unknown": "Unknown error"
      }
    },
    "notes": {
      "title": "Notes",
      "subtitle": "Internal — visible to admin staff only.",
      "loading": "Loading notes…",
      "pendingLabel": "No notes — endpoint in development.",
      "empty": "No internal notes recorded.",
      "addNoteLabel": "Add an internal note",
      "saving": "Saving…",
      "addNote": "Add note",
      "errors": {
        "unknown": "Unknown error"
      }
    },
    "pendingCostApprovals": {
      "title": "Pending Cost Approvals",
      "loading": "Loading proposals…",
      "pendingLabel": "No cost approval requests — endpoint in development.",
      "empty": "No pending cost change proposals.",
      "proposed": "Proposed {{date}}",
      "proposedBy": "by {{name}}",
      "actions": {
        "approve": "Approve",
        "reject": "Reject",
        "confirmReject": "Confirm Reject"
      },
      "rejectReasonLabel": "Reason",
      "errors": {
        "reasonRequired": "Rejection reason is required.",
        "unknown": "Unknown error"
      }
    },
    "products": {
      "title": "Products",
      "loading": "Loading products…",
      "pendingLabel": "No products — endpoint in development.",
      "empty": "No products yet.",
      "columns": {
        "sku": "SKU",
        "product": "Product",
        "status": "Status",
        "cost": "Cost"
      },
      "status": {
        "active": "Active",
        "pendingReapproval": "Pending re-approval",
        "paused": "Paused"
      },
      "variantCount": "({{count}} variants)",
      "showing": "Showing {{shown}} of {{total}} products."
    },
    "recentOrders": {
      "title": "Recent Orders",
      "subtitle": "Latest 20 orders. Use the orders page to see the full list.",
      "loading": "Loading orders…",
      "pendingLabel": "No recent orders — endpoint in development.",
      "empty": "No recent orders.",
      "columns": {
        "reference": "Reference",
        "merchant": "Merchant",
        "status": "Status",
        "total": "Total",
        "placed": "Placed"
      },
      "viewAll": "View all orders →"
    },
    "shell": {},
    "slaChart": {
      "title": "SLA Performance",
      "rangeAriaLabel": "SLA range",
      "months": "{{count}} months",
      "loading": "Loading SLA data…",
      "pendingLabel": "No SLA data — endpoint in development.",
      "empty": "No SLA data for the selected range.",
      "chartAriaLabel": "SLA performance line chart",
      "legend": {
        "fulfilment": "Fulfilment rate",
        "rejection": "Rejection rate"
      }
    },
    "staffAccounts": {
      "title": "Staff Accounts",
      "subtitle": "View-only. Suspension is the only mutation admins may perform on vendor staff.",
      "loading": "Loading staff…",
      "pendingLabel": "No staff accounts — endpoint in development.",
      "empty": "No staff accounts.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "status": "Status",
        "lastLogin": "Last login",
        "actions": "Actions"
      },
      "status": {
        "active": "Active",
        "suspended": "Suspended",
        "pending": "Pending"
      },
      "suspending": "Suspending…",
      "suspend": "Suspend",
      "reactivating": "Reactivating…",
      "reactivate": "Reactivate",
      "errors": {
        "unknown": "Unknown error"
      }
    },
    "feedback": {
      "defaultPending": "Feature in development — no data yet."
    }
  },
  "kycQueue": {
    "page": {
      "heading": "KYC Review Queue",
      "subtitle": "Each document is reviewed individually (compliance requirement —a). KYC only blocks payouts; vendors can still receive orders before approval."
    },
    "payoutBanner": {
      "title": "Payout notice:",
      "body": "one or more vendors in the list have payouts blocked because KYC is incomplete. Vendors can still receive orders — only payouts are held until all required documents are approved."
    },
    "tabs": {
      "ariaLabel": "Filter by status",
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "all": "All"
    },
    "search": {
      "label": "Search",
      "placeholder": "Search vendor or document type…"
    },
    "docTypes": {
      "business_license": "Business License",
      "id_card": "ID Card",
      "tax_cert": "Tax Certificate",
      "bank_proof": "Bank Proof"
    },
    "statusLabels": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "columns": {
      "vendor": "Vendor",
      "docType": "Document Type",
      "uploadedAt": "Uploaded",
      "docStatus": "Document Status",
      "rejectReason": "Reject Reason",
      "reviewer": "Reviewer",
      "reviewedAt": "Reviewed at",
      "vendorKyc": "Vendor KYC (total)",
      "actions": "Actions"
    },
    "empty": "No KYC documents match the current filter.",
    "loading": "Loading…",
    "payoutBlocked": "Payout blocked",
    "actions": {
      "viewAndReview": "View & Review",
      "loadMore": "Load more"
    },
    "toast": {
      "accessLogTitle": "Access log",
      "accessLogFail": "Failed to load access log",
      "listFail": "Failed to load KYC list",
      "approvedTitle": "KYC document approved",
      "approveFail": "Failed to approve KYC document",
      "rejectedTitle": "KYC document rejected",
      "rejectFail": "Failed to reject KYC document",
      "errorTitle": "Error"
    }
  },
  "kycViewer": {
    "ariaLabel": "KYC document viewer",
    "docTypes": {
      "business_license": "Business License",
      "id_card": "ID Card",
      "tax_cert": "Tax Certificate",
      "bank_proof": "Bank Proof"
    },
    "statusLabels": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "description": {
      "email": "Email: {{email}}",
      "uploadedAt": "Uploaded {{date}}",
      "fileSize": "Size {{size}}"
    },
    "statusRow": {
      "docStatus": "Document status:",
      "vendorKyc": "Vendor KYC:",
      "payoutBlocked": "Payout blocked",
      "payoutOpen": "Payout open"
    },
    "accessLog": {
      "title": "Access warning:",
      "body": "this document has been opened {{count}} times recently. Ensure you are viewing it for a legitimate reason — every access is recorded in the audit log."
    },
    "media": {
      "loading": "Loading document…",
      "unsupported": "File type not supported for inline viewing.",
      "download": "Download ({{name}})",
      "docAlt": "KYC document",
      "pdfTitle": "KYC document PDF"
    },
    "review": {
      "approved": "Approved by {{reviewer}}",
      "rejected": "Rejected by {{reviewer}}",
      "at": "At {{date}}",
      "rejectReasonLabel": "Reject reason:"
    },
    "rejectForm": {
      "label": "Reject reason (required, ≥ {{min}} characters)",
      "placeholder": "State the rejection reason clearly so the vendor can resubmit correctly…",
      "charCount": "{{count}}/{{max}} characters",
      "tooShort": "Minimum {{min}} characters required",
      "valid": "Valid"
    },
    "buttons": {
      "close": "Close",
      "cancelReject": "Cancel rejection",
      "processing": "Processing…",
      "confirmReject": "Confirm rejection",
      "reject": "Reject",
      "approve": "Approve"
    }
  },
  "pendingVendors": {
    "page": {
      "heading": "Pending Vendor Applications",
      "subtitle": "Review survey responses + approve or reject. AC-13."
    },
    "columns": {
      "vendor": "Vendor",
      "email": "Email",
      "country": "Country",
      "applied": "Applied",
      "survey": "Survey",
      "surveyPending": "Pending"
    },
    "search": {
      "placeholder": "Search vendors…"
    },
    "empty": "No pending vendor applications.",
    "toast": {
      "loadFailTitle": "Failed to load pending vendors",
      "networkError": "Network error",
      "unknownError": "Unknown error"
    }
  },
  "pendingCapabilities": {
    "noLabel": "(no label)",
    "heading": "Pending Capability Proposals",
    "badgeAriaLabel": "{{total}} pending proposals",
    "subtitle": "Aggregated capability proposals from all vendors. Auto-refreshes every 30 seconds.",
    "columns": {
      "vendor": "Vendor",
      "capability": "Proposed Capability",
      "type": "Type",
      "proposedAt": "Proposed at",
      "actions": "Actions"
    },
    "loading": "Loading list…",
    "empty": "No pending capability proposals",
    "actions": {
      "refresh": "Refresh",
      "refreshing": "Loading…",
      "review": "Review"
    },
    "toast": {
      "approved": "Capability proposal approved",
      "rejected": "Capability proposal rejected"
    }
  },
  "createWizard": {
    "stepperAriaLabel": "Vendor creation progress",
    "steps": {
      "basic": "Basic Info",
      "location_capabilities": "Location & Capabilities",
      "config": "Configuration"
    },
    "heading": "Create new vendor",
    "subheading": "3-step wizard. After creation the vendor will be in Pending Activation status and must be approved by an admin before receiving orders.",
    "progressTitle": "Progress",
    "toast": {
      "created": {
        "title": "Vendor created",
        "description": "Vendor is in Pending Activation status. Go to the list to approve activation."
      },
      "error": {
        "title": "Could not create vendor",
        "fallback": "Vendor creation failed.",
        "unknownHttp": "Unknown error (HTTP {{status}})."
      },
      "networkError": {
        "title": "Network error",
        "fallback": "Could not connect to the server."
      }
    }
  },
  "createSteps": {
    "validation": {
      "businessNameMin": "Business name must be at least 2 characters",
      "max120": "Maximum 120 characters",
      "legalNameMin": "Legal name must be at least 2 characters",
      "max160": "Maximum 160 characters",
      "emailInvalid": "Invalid email",
      "emailTooLong": "Email is too long",
      "phoneMin": "Phone number must have at least 6 digits",
      "phoneTooLong": "Phone number is too long",
      "countryIsoExample": "ISO 2-letter country code (e.g. VN, US)",
      "countryUppercase": "Country code must be uppercase",
      "timezoneInvalid": "Invalid timezone",
      "timezoneTooLong": "Timezone is too long",
      "timezoneIana": "IANA format (e.g. Asia/Ho_Chi_Minh)",
      "locationLabelMin": "Location label must be at least 2 characters",
      "addressMin": "Address must be at least 2 characters",
      "cityRequired": "City is required",
      "countryIso": "ISO 2-letter country code",
      "mustBeInteger": "Must be an integer",
      "capacityMax": "Maximum 100,000 orders / day",
      "pctRange": "Percentage must be between 0 and 100",
      "capabilitiesMax": "Maximum 50 capabilities",
      "warningLteCritical": "Warning (%) must be ≤ Critical (%)",
      "surchargeMax": "Maximum 10,000 bps (100%)",
      "notesMax": "Notes must be at most 2000 characters"
    },
    "basicInfo": {
      "heading": "Step 1 — Basic Info",
      "description": "Contact and legal identity information for the vendor (main vendor profile).",
      "fields": {
        "businessName": "Business name (display)",
        "legalName": "Legal name",
        "email": "Contact email",
        "phone": "Phone number",
        "country": "Country code (ISO-2)",
        "timezone": "Timezone (IANA)",
        "language": "Vendor language"
      },
      "languageOptions": {
        "vi": "Vietnamese",
        "en": "English"
      },
      "actions": {
        "cancel": "Cancel",
        "next": "Continue"
      },
      "timezonePlaceholder": "Asia/Ho_Chi_Minh"
    },
    "config": {
      "heading": "Step 3 — Configuration & Review",
      "description": "Configure quality tier and surcharge. After creation the vendor will be in Pending Activation status — it will not accept orders until an admin approves.",
      "review": {
        "title": "Review entered information",
        "businessName": "Business name",
        "legalName": "Legal name",
        "email": "Email",
        "phone": "Phone",
        "countryTimezone": "Country / Timezone",
        "language": "Language",
        "capacity": "Capacity",
        "capabilities": "Capabilities",
        "firstLocation": "First warehouse",
        "noCapabilities": "None selected",
        "capacityDisplay": "{{capacity}} orders/day — warning {{warning}}%, critical {{critical}}%"
      },
      "fields": {
        "qualityTier": "Quality tier",
        "surchargeBps": "Surcharge (basis points — 100 bps = 1%)",
        "holdPeriodTier": "Payout hold period",
        "notes": "Notes (optional)"
      },
      "qualityTierOptions": {
        "standard": "Standard",
        "preferred": "Preferred",
        "premium": "Premium"
      },
      "holdPeriodOptions": {
        "7d": "7 days",
        "14d": "14 days",
        "30d": "30 days"
      },
      "actions": {
        "back": "Back",
        "creating": "Creating…",
        "create": "Create vendor"
      }
    },
    "locationCapabilities": {
      "heading": "Step 2 — Location & Capabilities",
      "description": "First warehouse, capacity thresholds, and printing capabilities. After the vendor is active, additional warehouses can be added from the detail page.",
      "capacity": {
        "title": "Capacity thresholds",
        "globalLabel": "Total orders / day",
        "maxConcurrentLabel": "Max concurrent orders in processing",
        "warningPctLabel": "Warning threshold (%)",
        "criticalPctLabel": "Critical threshold (%)"
      },
      "capabilities": {
        "title": "Printing & shipping capabilities",
        "label": "Printing capabilities (select multiple)",
        "groupAriaLabel": "Printing capabilities",
        "loading": "Loading techniques…",
        "loadError": "Could not load the technique list.",
        "retry": "Retry"
      },
      "shippingMode": {
        "label": "Shipping mode",
        "options": {
          "hybrid": "Hybrid",
          "self_ship": "Self ship",
          "printway_processed": "Processed by Printway"
        }
      },
      "location": {
        "title": "First warehouse",
        "labelField": "Warehouse name",
        "address1": "Address line 1",
        "address2": "Address line 2 (optional)",
        "city": "City",
        "region": "State/Region (optional)",
        "postal": "ZIP code (optional)",
        "country": "Country (ISO-2)"
      },
      "actions": {
        "back": "Back",
        "next": "Continue"
      }
    }
  },
  "edit": {
    "heading": "Edit vendor",
    "subheading": "Editing {{name}} · all changes are recorded to the vendor audit trail.",
    "savedAt": "Saved · {{time}}",
    "loading": "Loading vendor for edit…",
    "errors": {
      "missingVendorId": "Missing vendor id in route.",
      "noPermission": "You do not have permission to edit vendors.",
      "loadFailed": "Failed to load vendor: {{message}}"
    },
    "fields": {
      "name": "Vendor name",
      "legalName": "Legal name",
      "email": "Email",
      "phone": "Phone",
      "primaryContact": "Primary contact",
      "country": "Country",
      "tier": "Tier"
    },
    "reasonLabel": "Reason for change (required, min 10 chars)",
    "validation": {
      "nameRequired": "Vendor name is required.",
      "reasonRequired": "Reason for change is required (minimum 10 characters)."
    },
    "dirty": {
      "changed": "{{count}} field(s) changed",
      "noPending": "No changes pending"
    },
    "actions": {
      "cancel": "Cancel",
      "back": "Back to vendor",
      "save": "Save changes",
      "saving": "Saving…"
    },
    "cancelDialog": {
      "title": "Discard unsaved changes?",
      "description": "The form has unsaved changes. Proceeding will discard them.",
      "keepEditing": "Keep editing",
      "discard": "Discard changes"
    }
  },
  "productDetail": {
    "backLink": "← Back to Vendor",
    "loading": "Loading product…",
    "errors": {
      "notFound": "Product not found (incorrect vendor or product id).",
      "loadFailed": "Error loading product: {{message}}"
    },
    "noName": "(untitled)",
    "fields": {
      "baseCost": "Base cost",
      "submission": "Submission",
      "blueprint": "Blueprint"
    },
    "openBlueprint": "Open blueprint →",
    "rejectReason": "Rejection reason: {{reason}}",
    "variantsTitle": "Variants ({{count}})",
    "noVariants": "No variants yet.",
    "variantColumns": {
      "sku": "SKU",
      "size": "Size",
      "color": "Color",
      "markup": "Markup",
      "price": "Price",
      "externalSku": "External SKU"
    },
    "approvalHistory": {
      "title": "Approval history",
      "events": "{{count}} event(s)",
      "lastEventSuffix": " · last: {{event}}",
      "lastEventAt": "Last event at {{when}}"
    }
  },
  "bulkImport": {
    "page": {
      "heading": "Bulk import vendors",
      "subtitle": "Upload a CSV to create multiple vendors at once. All imported vendors land in Pending Activation and require admin approval to activate."
    },
    "nav": {
      "ariaLabel": "Wizard progress"
    },
    "stepLabels": {
      "upload": "Upload",
      "mapColumns": "Map columns",
      "preview": "Preview",
      "commit": "Commit"
    },
    "toast": {
      "importFinished": "Import finished",
      "importFinishedDesc": "{{count}} vendor(s) created in Pending Activation.",
      "commitFailed": "Commit failed",
      "unknownError": "Unknown error"
    },
    "error": {
      "missingParseTitle": "Missing parse result",
      "missingParseDesc": "Please re-upload the CSV.",
      "missingValidateTitle": "Missing validation result",
      "missingValidateDesc": "Please re-run validation.",
      "noCommitTitle": "No commit result",
      "noCommitDesc": "Please start the import again.",
      "startOver": "Start over"
    }
  },
  "csvSteps": {
    "upload": {
      "heading": "Step 1 — Upload CSV",
      "subtitle": "Drop a CSV here, or click \"Browse files\". Files up to 5 MB.",
      "dragHere": "Drag a CSV file here",
      "selected": "Selected: {{name}}",
      "btn": {
        "uploading": "Uploading…",
        "browse": "Browse files",
        "downloadTemplate": "Download template"
      },
      "hint": {
        "before": "Required columns: name, email, phone, country (ISO 2-letter). Optional: displayName, language, timezone. Cells starting with",
        "orConnector": "or",
        "after": "will have the leading character stripped (CSV-injection protection)."
      },
      "toast": {
        "emptyTitle": "CSV is empty",
        "emptyDesc": "Select a file with at least one data row.",
        "tooLargeTitle": "CSV is too large",
        "tooLargeDesc": "File must be 5 MB or smaller. Yours is {{size}} MB.",
        "badTypeTitle": "Unsupported file type",
        "badTypeDesc": "Please choose a .csv file.",
        "parseFailTitle": "Could not parse CSV",
        "unknownError": "Unknown error"
      }
    },
    "mapping": {
      "heading": "Step 2 — Map columns",
      "subtitle": "Match each CSV column to a vendor field. Required fields: {{fields}}.",
      "skipColumn": "Skip column",
      "fieldLabels": {
        "name": "Name (required)",
        "email": "Email (required)",
        "phone": "Phone (required)",
        "country": "Country (required)",
        "displayName": "Display name",
        "language": "Language",
        "timezone": "Timezone"
      },
      "table": {
        "csvColumn": "CSV column",
        "sampleValues": "Sample values",
        "mapToField": "Map to vendor field",
        "emptyHeader": "(empty)",
        "noPreview": "(no preview)"
      },
      "validation": {
        "missingRequired": "Missing required field mapping: {{fields}}",
        "duplicates": "Each vendor field may only be mapped once. Duplicates: {{fields}}"
      },
      "btn": {
        "back": "Back",
        "validate": "Validate",
        "validating": "Validating…"
      },
      "toast": {
        "validationFailed": "Validation failed",
        "unknownError": "Unknown error"
      }
    },
    "preview": {
      "heading": "Step 3 — Preview & Validate",
      "subtitle": "Dry-run results. Fix any issues by going Back to edit the mapping or your source CSV; otherwise proceed to commit.",
      "stats": {
        "totalRows": "Total rows",
        "valid": "Valid",
        "invalid": "Invalid"
      },
      "truncatedNotice": "Showing the first {{shown}} issues. The full error count is {{total}}. Download the error report to inspect what is shown here.",
      "noIssues": "No issues detected. {{count}} rows ready to import.",
      "table": {
        "rowNum": "Row #",
        "issues": "Issues"
      },
      "btn": {
        "back": "Back",
        "downloadErrorReport": "Download error report",
        "importing": "Importing…",
        "import": "Import {{count}} valid rows"
      },
      "errorReportTruncatedComment": "# Truncated — list limited to first {{shown}} issues; total invalid rows: {{total}}"
    },
    "commit": {
      "heading": "Step 4 — Import complete",
      "subtitleOk": "All valid rows were imported. Each new vendor lands in Pending Activation; review them in the vendor approval queue.",
      "subtitlePartial": "Import finished with partial results — see below.",
      "stats": {
        "totalRows": "Total rows",
        "inserted": "Inserted",
        "skipped": "Skipped",
        "errors": "Errors"
      },
      "skippedReason": "skipped — email already exists or insert failed",
      "skippedRows": {
        "prefix": "Skipped rows:",
        "more": " and {{count}} more",
        "hint": "Common cause: the email already exists in the database. Download the skipped-row report to triage manually."
      },
      "btn": {
        "downloadSkipped": "Download skipped report",
        "startAnother": "Start another import",
        "done": "Done"
      }
    }
  },
  "costApproval": {
    "queue": {
      "page": {
        "heading": "Vendor Cost Approval Queue",
        "description": "Vendors submit production / seasonal / surcharge price proposals from the portal; admin approves or rejects them here. The old price remains active until the new proposal is approved. Every action is recorded in the audit log."
      },
      "tabs": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected",
        "all": "All"
      },
      "tablist": {
        "ariaLabel": "Filter by status"
      },
      "filter": {
        "costTypeLabel": "Cost type",
        "allCostTypes": "All cost types"
      },
      "costTypeLabels": {
        "production": "Production",
        "seasonal": "Seasonal",
        "surcharge": "Surcharge"
      },
      "vendorFilter": {
        "prefix": "Filtering by vendor:",
        "clear": "Clear filter"
      },
      "columns": {
        "vendor": "Vendor",
        "variant": "Variant",
        "type": "Type",
        "current": "Current",
        "proposed": "Proposed",
        "delta": "Δ%",
        "proposedBy": "Proposed by",
        "submittedAt": "Submitted at",
        "actionsHeader": "Actions",
        "statusHeader": "Status"
      },
      "loading": "Loading…",
      "empty": "No price proposals match the current filters.",
      "statusLabels": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "toast": {
        "approveSuccess": "Vendor price proposal approved",
        "rejectSuccess": "Vendor price proposal rejected",
        "errorTitle": "Error"
      },
      "errors": {
        "loadFailed": "Failed to load approval queue",
        "approveFailed": "Failed to approve proposal",
        "rejectFailed": "Failed to reject proposal"
      }
    },
    "detail": {
      "title": "Review vendor price proposal",
      "closeAriaLabel": "Close dialog",
      "costTypeLabels": {
        "production": "Production (manufacturing cost)",
        "seasonal": "Seasonal (seasonal surcharge)",
        "surcharge": "Surcharge (handling fee)"
      },
      "meta": {
        "costType": "Cost type",
        "proposedBy": "Proposed by",
        "submittedAt": "Submitted at",
        "status": "Status"
      },
      "statusText": {
        "pending": "Awaiting approval",
        "approved": "Approved · {{reviewedAt}}",
        "rejected": "Rejected · {{reviewedAt}}"
      },
      "diff": {
        "ariaLabel": "Compare current price and proposed price",
        "currentLabel": "Current price (live)",
        "noCurrent": "(none)",
        "proposedLabel": "Proposed price (new)",
        "deltaLabel": "Difference:"
      },
      "savedRejectReason": "Saved rejection reason:",
      "rejectForm": {
        "label": "Rejection reason",
        "placeholder": "State the reason clearly so the vendor can revise and submit a new proposal.",
        "minHint": "Minimum {{min}} characters.",
        "tooShortError": "Rejection reason must be at least {{min}} characters (current: {{current}})."
      },
      "actions": {
        "close": "Close",
        "reject": "Reject",
        "approve": "Approve",
        "approving": "Processing…",
        "back": "Back",
        "submitting": "Submitting…",
        "confirmReject": "Confirm rejection"
      }
    },
    "rowActions": {
      "statusLabels": {
        "approved": "Approved",
        "rejected": "Rejected",
        "pending": "Pending"
      },
      "approveButton": "Approve",
      "rejectButton": "Reject",
      "approveAriaLabel": "Approve vendor price proposal",
      "rejectAriaLabel": "Reject vendor price proposal"
    }
  },
  "modals": {
    "activationApprove": {
      "title": "Approve vendor activation",
      "descWithName": "Vendor <strong>{{name}}</strong> will be set to <strong>Active</strong> status and will receive an activation email.",
      "descGeneric": "The vendor will be set to <strong>Active</strong> status and will receive an activation email.",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Reason or internal note — not sent to vendor",
      "cancel": "Cancel",
      "submittingLabel": "Approving…",
      "submit": "Approve",
      "networkError": "Network error — check connection"
    },
    "activationReject": {
      "title": "Reject vendor activation",
      "descWithName": "Vendor <strong>{{name}}</strong> will be set to <strong>Rejected</strong> status and will receive an email with the reason.",
      "descGeneric": "The vendor will be set to <strong>Rejected</strong> status and will receive an email with the reason.",
      "reasonLabel": "Rejection reason",
      "reasonPlaceholder": "Enter reason (minimum {{min}} characters)…",
      "remaining": "{{count}} more characters needed",
      "valid": "Sufficient",
      "cancel": "Cancel",
      "submittingLabel": "Processing…",
      "submit": "Reject",
      "networkError": "Network error — check connection"
    },
    "atRiskAcknowledge": {
      "title": "Acknowledge At-Risk flag",
      "descWithNameAndVendor": "The <strong>{{flag}}</strong> flag on vendor <strong>{{name}}</strong> will be marked as reviewed. Vendor status remains unchanged — you still need to make a separate decision (suspend / warn / keep).",
      "descGenericWithFlag": "The <strong>{{flag}}</strong> flag will be marked as reviewed. Vendor status remains unchanged.",
      "metricsHeading": "Reference metrics",
      "metricRatingAvg": "Average rating",
      "metricSampleSize": "Sample size",
      "metricRejectRate": "Rejection rate",
      "metricComplaintCount": "Complaint count",
      "metricWindowHours": "Time window",
      "flagLabels": {
        "low_rating": "Low Rating",
        "high_rejection": "High Rejection",
        "complaint_spike": "Complaint Spike"
      },
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Internal reason or decision — not sent to vendor",
      "cancel": "Cancel",
      "submittingLabel": "Saving…",
      "submit": "Acknowledge",
      "networkError": "Network error — check connection"
    },
    "bankAccountVerify": {
      "title": "Verify vendor bank account",
      "descWithName": "Review the bank account information submitted by vendor <strong>{{name}}</strong>.",
      "descGeneric": "Review the bank account information submitted by the vendor.",
      "fieldMethod": "Method",
      "fieldHolder": "Account holder",
      "fieldNumber": "Account number",
      "fieldBank": "Bank",
      "fieldSwift": "SWIFT",
      "fieldStatus": "Status",
      "statusVerified": "Verified",
      "statusPending": "Pending verification",
      "alreadyVerifiedNotice": "This account has already been verified. No further action required.",
      "decisionAriaLabel": "Decision",
      "decisionVerify": "Verify",
      "decisionReject": "Reject",
      "reasonLabel": "Rejection reason",
      "reasonPlaceholder": "Enter reason (minimum {{min}} characters)…",
      "remaining": "{{count}} more characters needed",
      "valid": "Sufficient",
      "verifyNote": "Verification does not trigger an immediate payout. The vendor must still reach approved KYC status to unlock withdrawals.",
      "close": "Close",
      "cancel": "Cancel",
      "submittingLabel": "Processing…",
      "submitVerify": "Verify",
      "submitReject": "Reject",
      "networkError": "Network error — check connection"
    },
    "capabilityAssign": {
      "title": "Assign capability to vendor",
      "descWithName": "Assign a new capability to vendor <strong>{{name}}</strong>. The capability takes effect immediately (no vendor confirmation required).",
      "descGeneric": "Assign a new capability to the vendor. The capability takes effect immediately (no vendor confirmation required).",
      "capabilityLabel": "Capability",
      "selectAllAssigned": "— Vendor already has all capabilities in the catalog —",
      "selectPlaceholder": "— Select capability —",
      "processingLabel": "Processing time (days)",
      "processingHint": "{{min}}…{{max}} days",
      "capacityLabel": "Capacity / day",
      "capacityHint": "{{min}}…{{max}} units",
      "baseCostLabel": "Base cost (cents)",
      "baseCostHint": "{{min}}…{{max}} cents",
      "cancel": "Cancel",
      "submittingLabel": "Assigning…",
      "submit": "Assign capability",
      "networkError": "Network error — check connection"
    },
    "capabilityProposal": {
      "title": "Review capability proposal",
      "descWithNameAndBlueprint": "Vendor <strong>{{name}}</strong> proposed a capability for blueprint <strong>{{blueprint}}</strong>.",
      "descWithName": "Vendor <strong>{{name}}</strong> proposed a capability.",
      "descGeneric": "A vendor capability proposal is awaiting approval.",
      "proposalContentLabel": "Proposal details",
      "decisionAriaLabel": "Decision",
      "decisionApprove": "Approve",
      "decisionReject": "Reject",
      "reasonLabel": "Rejection reason",
      "reasonPlaceholder": "Enter reason (minimum {{min}} characters)…",
      "remaining": "{{count}} more characters needed",
      "valid": "Sufficient",
      "cancel": "Cancel",
      "submittingLabel": "Processing…",
      "submitApprove": "Approve",
      "submitReject": "Reject",
      "networkError": "Network error — check connection"
    },
    "vendorReactivate": {
      "title": "Reactivate vendor",
      "descWithName": "Vendor <strong>{{name}}</strong> will be restored to <strong>Active</strong> status. Payouts will be unlocked and the vendor can accept orders again.",
      "descGeneric": "The vendor will be restored to <strong>Active</strong> status. Payouts will be unlocked and the vendor can accept orders again.",
      "reasonLabel": "Reactivation reason (optional)",
      "reasonPlaceholder": "Internal note about the reactivation reason — not required",
      "cancel": "Cancel",
      "submittingLabel": "Reactivating…",
      "submit": "Reactivate",
      "networkError": "Network error — check connection"
    },
    "vendorSuspend": {
      "title": "Suspend vendor",
      "descWithName": "Vendor <strong>{{name}}</strong> will be suspended. Payouts will be blocked and pending orders will be paused until the vendor is reactivated.",
      "descGeneric": "The vendor will be suspended. Payouts will be blocked and pending orders will be paused until the vendor is reactivated.",
      "tierHoldPeriodPrefix": "Hold period:",
      "tier1Label": "7 days",
      "tier1Desc": "Rating is 0.8 or above, so the hold period will be 7 days from now.",
      "tier2Label": "14 days",
      "tier2Desc": "Rating is between 0.5 and 0.79 (or not yet rated), so the hold period will be 14 days from now.",
      "reasonLabel": "Suspension reason",
      "reasonPlaceholder": "Enter reason (minimum {{min}} characters)…",
      "remaining": "{{count}} more characters needed",
      "valid": "Sufficient",
      "cancel": "Cancel",
      "submittingLabel": "Suspending…",
      "submit": "Suspend vendor",
      "networkError": "Network error — check connection",
      "tier3Label": "21 days",
      "tier3Desc": "Rating is below 0.5, so the hold period will be 21 days from now."
    },
    "walletHoldRelease": {
      "holdTitle": "Hold vendor wallet",
      "holdDescWithName": "Vendor <strong>{{name}}</strong>'s wallet will be put on hold. The vendor cannot withdraw funds or create new payouts until it is released.",
      "holdDescGeneric": "The vendor wallet will be put on hold. The vendor cannot withdraw funds or create new payouts until it is released.",
      "holdSubmit": "Hold wallet",
      "holdSubmitting": "Placing hold…",
      "releaseTitle": "Release vendor wallet",
      "releaseDescWithName": "Vendor <strong>{{name}}</strong>'s wallet will be released. The vendor can create payouts / withdraw funds normally.",
      "releaseDescGeneric": "The vendor wallet will be released. The vendor can create payouts / withdraw funds normally.",
      "releaseSubmit": "Release wallet",
      "releaseSubmitting": "Releasing…",
      "reasonLabel": "Reason",
      "reasonMinHint": "(minimum {{min}} characters)",
      "holdPlaceholder": "Reason for hold — logged for audit, not sent to vendor",
      "releasePlaceholder": "Reason for release — logged for audit, not sent to vendor",
      "remaining": "{{count}} more characters needed",
      "cancel": "Cancel",
      "networkError": "Network error — check connection"
    },
    "walletAdjustment": {
      "networkError": "Network error — check connection"
    }
  },
  "settings": {
    "title": "Vendor Settings",
    "subtitle": "Configure vendor-level allocation and mapping.",
    "tablistAria": "Vendor settings tabs",
    "tabs": {
      "mapping": "Mapping"
    }
  },
  "catalog": {
    "pageTitle": "Vendor",
    "pageSubtitle": "Manage your vendor partners, supplier details, and production capabilities.",
    "searchPlaceholder": "Search vendors...",
    "statusAll": "Status: All",
    "statusActive": "Status: Active",
    "statusInactive": "Status: Inactive",
    "create": "Create",
    "colName": "Name",
    "colCode": "Code",
    "colLocation": "Location",
    "colCreatedDate": "Created date",
    "colLastUpdate": "Last update",
    "colCreator": "Creator",
    "colLastEditor": "Last edited by",
    "colStatus": "Status",
    "colActions": "Action",
    "loading": "Loading vendors…",
    "loadError": "Failed to load vendors.",
    "retry": "Retry",
    "emptyNone": "No vendors yet.",
    "emptySearch": "No vendor matches this search.",
    "rowsPerPage": "Rows per page:",
    "showingRange": "Showing {{from}}–{{to}} of {{total}} vendors",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "paginationAria": "Vendor list pagination",
    "statusToggleAria": "Toggle status for {{name}}",
    "editAria": "Edit {{name}}",
    "productsAria": "View products of {{name}}",
    "statusSaved": "Status saved.",
    "statusFailed": "Could not change the status",
    "manageLink": "Advanced view",
    "toggleReason": "Status changed from the vendor list by an administrator.",
    "statusError": {
      "notFound": "That vendor no longer exists, or is not a vendor account.",
      "stateInvalid": "Only a suspended vendor can be reactivated — this one is not suspended.",
      "alreadySuspended": "That vendor is already suspended.",
      "internal": "The server could not complete the change. Try again, or contact support if it persists.",
      "generic": "The server refused the change and did not say why."
    }
  },
  "productsSheet": {
    "title": "Products — {{vendor}}",
    "subtitle": "Products this vendor can manufacture and fulfill.",
    "close": "Close",
    "authLoading": "Checking your permissions…",
    "authError": "Couldn't load your permissions, so editing is unavailable.",
    "authRetry": "Try again",
    "searchPlaceholder": "Search products...",
    "colProductType": "Product type",
    "colProductCode": "Product code",
    "colDateCreated": "Date created",
    "colUserCreated": "User created",
    "colStatus": "Status",
    "loading": "Loading products…",
    "loadError": "Failed to load this vendor’s products.",
    "emptyNone": "This vendor has no products yet.",
    "emptySearch": "No product matches this search.",
    "showingRange": "Showing {{from}}–{{to}} of {{total}} products",
    "statusToggleAria": "Turn {{name}} on or off",
    "statusSaved": "Product status updated.",
    "statusError": "Couldn't change the product status.",
    "statusConflict": "This product's state just changed. Reload and try again.",
    "statusLocked": "Pending or rejected products change through the approval flow.",
    "confirmOffTitle": "Turn off this product?",
    "confirmOffBody": "{{name}} is turned off now, instead of after the vendor's 7-day notice.",
    "confirmOff": "Turn off",
    "cancel": "Cancel",
    "openSkusAria": "Open the SKUs of {{name}}",
    "statusFilterAll": "Status: All",
    "statusFilterActive": "Status: Active",
    "statusFilterInactive": "Status: Inactive",
    "refreshing": "Refreshing…",
    "skus": {
      "back": "Back to products",
      "subtitle": "Manage SKUs, pricing, dimensions, and shipping fees for this product.",
      "searchPlaceholder": "Search SKUs...",
      "bulkOrder": "Bulk Order",
      "bulkAllAria": "Bulk order for every SKU of this product",
      "bulkPartial": "{{count}}/{{total}}",
      "bulkConfirmOnTitle": "Turn on bulk order for every SKU?",
      "bulkConfirmOffTitle": "Turn off bulk order for every SKU?",
      "bulkConfirmBody": "This changes all {{total}} SKUs of the product, including the ones not on this page.",
      "bulkConfirm": "Apply",
      "bulkSaved": "Bulk order updated for {{count}} SKUs.",
      "colSkuName": "SKU name",
      "colSkuCode": "SKU code",
      "colCostPrice": "Cost price",
      "colHandleFee": "Handle fee",
      "colDimension": "Dimension",
      "colShippingInfo": "Shipping info",
      "colBulkOrder": "Bulk order",
      "colStatus": "Status",
      "dimensionValue": "{{l}} × {{w}} × {{h}} cm · {{g}}g",
      "editDimensionsAria": "Edit the dimensions of {{sku}}",
      "view": "View",
      "hide": "Hide",
      "shippingToggleAria": "Shipping info of {{sku}}",
      "skuStatusAria": "Turn SKU {{sku}} on or off",
      "skuBulkAria": "Bulk order for SKU {{sku}}",
      "saved": "SKU updated.",
      "saveError": "Couldn't save the SKU.",
      "loading": "Loading SKUs…",
      "loadError": "Failed to load this product's SKUs.",
      "emptyNone": "This product has no SKUs yet.",
      "emptySearch": "No SKU matches this search.",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} SKUs",
      "linkMapped": "Mapped · awaiting approval",
      "linkAllocated": "Linked · allocated",
      "linkNoAllocation": "Linked · no allocation"
    },
    "dimensions": {
      "title": "Set Dimensions",
      "subtitle": "Configure box dimensions",
      "weight": "Weight",
      "boxHeight": "Box Height",
      "boxWidth": "Box Width",
      "boxLength": "Box Length",
      "unitG": "g",
      "unitCm": "cm",
      "save": "Save",
      "cancel": "Cancel",
      "invalid": "Enter a number greater than 0.",
      "rejected": "This value was not accepted. Check it and try again.",
      "saved": "Dimensions saved."
    },
    "shipping": {
      "colService": "Service name",
      "colShippingFee": "Shipping fee",
      "colShippingCost": "Shipping cost",
      "colTariff": "Reciprocal tariff",
      "colAdditionalFee": "Additional fee",
      "colAdditionalCost": "Additional cost",
      "colStatus": "Status",
      "emptyMethods": "No active shipping service. Add one under Vendors → Services.",
      "statusAria": "{{service}} for this SKU",
      "invalidAmount": "Enter an amount like 5.00",
      "feeAria": "{{field}} — {{service}}",
      "required": "Required",
      "unsavedSummary": "Unsaved: {{changes}} in {{skus}}",
      "unsavedChanges_one": "{{count}} unsaved change",
      "unsavedChanges_other": "{{count}} unsaved changes",
      "skuCount_one": "{{count}} SKU",
      "skuCount_other": "{{count}} SKUs",
      "invalidCount_one": "{{count}} field needs fixing",
      "invalidCount_other": "{{count}} fields need fixing",
      "invalidElsewhere": "On another page or filter: {{skus}}",
      "saveAll": "Save changes",
      "discardAll": "Discard changes",
      "savedBatch_one": "Saved {{count}} shipping row.",
      "savedBatch_other": "Saved {{count}} shipping rows.",
      "savedNothing": "Nothing changed.",
      "leaveTitle": "Unsaved changes",
      "leaveBody_one": "You have {{count}} unsaved change. Save it before leaving?",
      "leaveBody_other": "You have {{count}} unsaved changes. Save them before leaving?",
      "leaveSave": "Save & continue",
      "leaveDiscard": "Discard",
      "leaveStay": "Stay",
      "leaveInvalid": "Some fields are invalid — fix them or discard the changes.",
      "editedAria": "edited",
      "saveError": "Couldn't save the shipping changes.",
      "rowRefused": "Not saved — this row was refused.",
      "discardRow": "Discard this row",
      "markDraft": "unsaved shipping changes",
      "markError": "shipping fields need fixing"
    },
    "pricing": {
      "costAria": "Cost price of {{sku}}",
      "handleAria": "Handle fee of {{sku}}",
      "costLocked": "This product is awaiting approval — cost price is locked until it is reviewed.",
      "required": "Required",
      "invalidAmount": "Enter an amount like 5.00",
      "savedBatch_one": "Saved prices of {{count}} SKU.",
      "savedBatch_other": "Saved prices of {{count}} SKUs.",
      "savedAll": "Prices and shipping saved.",
      "partialSaved": "Prices saved; shipping changes were not saved.",
      "saveError": "Couldn't save the prices. Nothing was saved.",
      "errCostGuard": "Cost must stay below the lowest merchant price.",
      "errCostGuardTier": "Cost must stay below the lowest merchant price ({{tier}}).",
      "errPending": "The product is awaiting approval — cost cannot change now.",
      "errConfigNotApproved": "The Printway link of this SKU is awaiting approval.",
      "errPricingMissing": "The Printway SKU has no merchant price yet.",
      "errNotFound": "This SKU no longer exists.",
      "errRefused": "Not saved — this value was refused."
    }
  },
  "services": {
    "pageTitle": "Services",
    "pageSubtitle": "Manage your shipping services, delivery methods, and transit configurations.",
    "searchPlaceholder": "Search services...",
    "create": "Create",
    "colImage": "Image",
    "colName": "Service name",
    "colCode": "Service code",
    "colDescription": "Description",
    "colShippingTime": "Shipping time",
    "colStatus": "Status",
    "colActions": "Action",
    "loading": "Loading services…",
    "loadError": "Failed to load services.",
    "retry": "Retry",
    "emptyNone": "No shipping services yet.",
    "emptySearch": "No service matches this search.",
    "rowsPerPage": "Rows per page:",
    "showingRange": "Showing {{from}}–{{to}} of {{total}} services",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "paginationAria": "Service list pagination",
    "statusToggleAria": "Toggle status for {{name}}",
    "editAria": "Edit {{name}}",
    "statusSaved": "Status saved.",
    "statusFailed": "Could not change the status",
    "carrierHint": "Not mapped to a carrier yet — map it on Shipping › Config › Service.",
    "breadcrumbServices": "Services",
    "breadcrumbShipping": "Shipping",
    "breadcrumbCreate": "Create",
    "breadcrumbEdit": "Edit",
    "createTitle": "Create Shipping Service",
    "createSubtitle": "Add a new shipping service to the system.",
    "editTitle": "Edit Shipping Service",
    "editSubtitle": "Update this shipping service.",
    "sectionInfo": "Service Information",
    "imageLabel": "Service Image",
    "imageCta": "Click to upload or drag and drop",
    "imageHint": "PNG, JPG up to 2MB (1:1 ratio recommended)",
    "imageRemove": "Remove image",
    "imageTooLarge": "That image is larger than 2MB.",
    "imageWrongType": "Only PNG and JPG images are accepted.",
    "nameLabel": "Service Name",
    "namePlaceholder": "Enter service name",
    "codeLabel": "Service Code",
    "codePlaceholder": "e.g. STD-SHP",
    "codeHint": "A unique code for identifying this service.",
    "codeLockedHint": "The service code cannot be changed after creation.",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Enter a brief description of this shipping service",
    "shippingTimeLabel": "Shipping Time",
    "shippingTimePlaceholder": "e.g. 7-14 days",
    "shippingTimeHint": "Estimated delivery time range.",
    "statusLabel": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "statusDraft": "Draft",
    "cancel": "Cancel",
    "submitCreate": "Create Service",
    "submitSave": "Save changes",
    "saving": "Saving…",
    "created": "Service created.",
    "updated": "Service saved.",
    "nameRequired": "Service name is required",
    "codeRequired": "Service code is required",
    "codeFormat": "Code must be uppercase letters, digits, - or _ (2–40 characters)",
    "codeDuplicate": "Another service already uses this code",
    "shippingTimeRequired": "Shipping time is required",
    "createFailed": "Could not create the service",
    "updateFailed": "Could not save the service",
    "loadFailed": "Could not load this service"
  }
}
